import React from "react";
import { Box, Button } from "@curves/ui-base";
import inBodyImage from "@icoach/assets/img/image-7.png";
import useDocHealthDeclarationApi from "@apis/useDocHealthDeclarationApi";
import { useInBodyContext } from "@icoach/inbody/components/InBodyContext";
import { MEMBERSHIP_STATUS } from "@icoach/constants/";
import { isEmpty, isEqual } from "@util/utils";

const isValidMembers = [MEMBERSHIP_STATUS.NORMAL, MEMBERSHIP_STATUS.SUSPEND];

// 會員與教練共用量身按鈕
const InBodyMeasurementTriggerButton = props => {
	const { dialogRef, memberProfile = {}, peopleID, referenceType } = useInBodyContext();
	const { getHealthDeclarationRequiredApi } = useDocHealthDeclarationApi();
	const handleOnclick = () => {
		if (!isEmpty(memberProfile)) {
			// 會員
			getMemberDocumentFillingStatusApi();
		} else {
			// 教練
			dialogRef.current.openInBodyMeasurementTriggerDialog({
				referenceType: referenceType,
				peopleID: peopleID,
			});
		}
	};
	const getMemberDocumentFillingStatusApi = async () => {
		const resp = await getHealthDeclarationRequiredApi({ memberID: peopleID });
		if (resp) {
			// 無需填寫直接量身
			dialogRef.current.openInBodyMeasurementTriggerDialog({
				referenceType: referenceType,
				peopleID: peopleID,
			});
		} else {
			const { membershipStatus } = memberProfile || {};
			dialogRef.current.openInBodyHealthDeclarationReminderDialog({
				isValidMember: isValidMembers.some(x => isEqual(x, membershipStatus)),
				peopleID: peopleID,
				referenceType: referenceType,
				onOpenMeasurementDialog: target => dialogRef.current.openInBodyMeasurementTriggerDialog(target),
			});
		}
	};

	return (
		<Button className="measure-weight-button" variant="contained" onClick={handleOnclick}>
			<React.Fragment>
				<Box component="img" src={inBodyImage} />
				進行量身
			</React.Fragment>
		</Button>
	);
};

export default InBodyMeasurementTriggerButton;
